











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportAllTasksMenuRoot_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "teamId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ExportAllTasksMenu_meeting"
    }
  ],
  "type": "NewMeeting",
  "abstractKey": "__isNewMeeting"
};

(node ).hash = "70f9fd93fb9f55811bb1e6ed7042c642";

export default node;
